import createHistory from 'history/createBrowserHistory';
const history = createHistory();
const parentPath = path => path
    .split('/')
    .slice(0, -1)
    .join('/');
export const toParentPath = () => history.replace(parentPath(history.location.pathname));
export default history;



//////////////////
// WEBPACK FOOTER
// ./src/helpers/History.ts
// module id = 15
// module chunks = 0